const cta = document.getElementById( 'labCoverCta' );
const labCover = document.getElementById( 'labCover' );
const labCoverVideo = document.getElementById( 'labCoverVideo' );

/**
 * Setup
 */
const setup = () => {

	// Create button
	createCtaButton();

	// Set attributes
	labCoverVideo.setAttribute( 'tabindex', '-1' );
	labCoverVideo.setAttribute( 'aria-hidden', true );
	labCoverVideo.setAttribute( 'aria-labelledby', 'labCoverCtaButton' );
};

/**
 * Creates the CTA button
 */
const createCtaButton = () => {
	const button = document.createElement( 'button' );

	// Button attributes / HTML
	button.classList.add( 'lab-cover__cta' );
	button.classList.add( 'button' );
	button.setAttribute( 'type', 'button' );
	button.setAttribute( 'id', 'labCoverCtaButton' );
	button.setAttribute( 'aria-controls', 'labCoverVideo' );
	button.setAttribute( 'aria-expanded', false );
	button.innerHTML = cta.innerHTML;

	// Replace button
	cta.parentNode.replaceChild( button, cta );

	// Listeners
	button.addEventListener( 'click', onCtaClick );
};

/**
 * On CTA click handler
 * @param {object} event the event object
 */
const onCtaClick = ( event ) => {
	const button = event.target;

	// Don't follow external link
	event.preventDefault();

	// Attributes
	button.setAttribute( 'aria-expanded', true );
	labCoverVideo.setAttribute( 'aria-hidden', false );

	// Update classes.
	// This will cause transitions in CSS
	labCover.classList.add( 'lab-cover--showing-media' );

	// Focus
	labCoverVideo.focus();
};

/**
 * Init for module
 */
const init = () => {

	// If not labs page, bail.
	if ( ! document.querySelector( 'body' ).classList.contains( 'single-msr-research-lab' ) ) {
		return;
	}

	// If no lab cover or video, bail.
	if ( ! labCover || ! labCoverVideo ) {
		return;
	}

	// Run setup.
	setup();

};

// Exports
export default init;
